import React from 'react'

type ComponentChild = Exclude<React.ReactNode, boolean | null | undefined>

export const isElement =
  <T extends React.ComponentType>(Element: T) =>
  (child: ComponentChild): child is React.ReactElement<React.ComponentProps<T>> =>
    React.isValidElement(child) && child.type === Element
